// src/features/clinical/pages/VisitHistoryPage.jsx
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import VisitHistory from '../components/visit/VisitHistory';
import clinicalApi from '../services/clinicalApi';

const VisitHistoryPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [visits, setVisits] = useState([]);
  const [patient, setPatient] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, [id]);

  const loadData = async () => {
    try {
      const [patientRes, visitsRes] = await Promise.all([
        clinicalApi.getPatient(id),
        clinicalApi.getVisits(id)
      ]);
      setPatient(patientRes.data);
      setVisits(visitsRes.data);
    } catch (error) {
      console.error('Failed to load data:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4">
      <div className="mb-6 flex items-center">
        <button
          onClick={() => navigate(-1)}
          className="mr-4 text-gray-600 hover:text-gray-900"
        >
          <FaArrowLeft className="h-5 w-5" />
        </button>
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Visit History</h1>
          {patient && (
            <p className="text-gray-600">{patient.name} - {patient.patientId}</p>
          )}
        </div>
      </div>

      <VisitHistory visits={visits} />
    </div>
  );
};

export default VisitHistoryPage;